import React, { Component } from 'react';
import { withStyles } from "@material-ui/core/styles";
import { Switch } from "@material-ui/core";

const AntSwitch = withStyles(theme => ({
    root: {
        width: 48,
        height: 24,
        padding: 0,
        display: 'flex',
    },
    switchBase: {
        padding: 4,
        color: theme.palette.grey[500],
        '&$checked': {
            color: theme.palette.common.white,
            transform: 'translateX(-100%)',
            '& + $track': {
                opacity: 1,
                backgroundColor: theme.palette.common.white,
            },
        },
        '&:hover': {
            backgroundColor: '#FFF'
        }
    },
    thumb: {
        width: 16,
        height: 16,
        boxShadow: 'none',
        backgroundColor: '#6EA0D7'
    },
    track: {
        border: '1px solid #E6EDF5',
        borderRadius: 24 / 2,
        opacity: 1,
        backgroundColor: theme.palette.common.white,
    },
    checked: {},
}))(Switch);



class SwitchMaterialUI extends Component {

    constructor(props) {
        super(props)
        this.state = {
            status : this.props.value
        }
    }

    onChangeHandler = (event) => {
        this.props.onChangeHandler(!this.state.status);
        this.setState({
            status: !this.state.status
        })
    }

    render() {
        
        return (
            <React.Fragment>
                <AntSwitch
                    checked={this.state.status}
                    onChange={(event) => this.onChangeHandler(event)}
                    value={this.state.status}
                />
            </React.Fragment>
        );
    }
}

export default SwitchMaterialUI;